//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { getAuth0Token, getVectorBaseUrl, transformApiResult, transformRequestOptions } from './VectorClientHelpers';
export class VectorClientBase { 

  protected transformOptions(options: any) {
    return this.getToken().then(newToken => transformRequestOptions(newToken, options));
  }
  
  protected transformResult(url: string, response: Response, processor: (response: Response) => any) {
    return transformApiResult(url, response, processor);
  }

  protected getBaseUrl(urlTemplate: string, defaultUrl: string | undefined): string {
    return getVectorBaseUrl(urlTemplate, defaultUrl);
  }

  private async getToken() {
    return getAuth0Token();
  }
}

export interface ITaskboardsClient {

    /**
     * @return Success
     */
    boardsAll(vaultId: number): Promise<BoardApiModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    boardsPOST(vaultId: number, body?: BoardCreationRequest | undefined): Promise<BoardApiModel>;

    /**
     * @return Success
     */
    archived(vaultId: number): Promise<BoardApiModel[]>;

    /**
     * @return Success
     */
    boardsGET(vaultId: number, boardId: number): Promise<BoardApiModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    boardsPUT(vaultId: number, boardId: number, body?: BoardUpdateRequest | undefined): Promise<BoardApiModel>;

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    boardsDELETE(vaultId: number, boardId: number, shouldDelete?: boolean | undefined): Promise<BoardApiModel>;

    /**
     * @return Success
     */
    export(vaultId: number, boardId: number): Promise<BoardExportModel>;

    /**
     * @param file (optional) 
     * @return Success
     */
    import(vaultId: number, file?: FileParameter | undefined): Promise<BoardApiModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    protect(vaultId: number, boardId: number, body?: BoardProtectionRequest | undefined): Promise<BoardProtectionResult>;

    /**
     * @return Success
     */
    unarchive(vaultId: number, boardId: number): Promise<BoardApiModel>;

    /**
     * @return Success
     */
    goalsAll(vaultId: number, boardId: number): Promise<GoalApiModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    goalsPOST(vaultId: number, boardId: number, body?: GoalCreationRequest | undefined): Promise<GoalApiModel>;

    /**
     * @return Success
     */
    goalsGET(vaultId: number, boardId: number, goalId: number): Promise<TaskListApiModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    goalsPUT(vaultId: number, boardId: number, goalId: number, body?: GoalUpdateRequest | undefined): Promise<TaskListApiModel>;

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    goalsDELETE(vaultId: number, boardId: number, goalId: number, shouldDelete?: boolean | undefined): Promise<void>;

    /**
     * @return Success
     */
    initiativesAll(vaultId: number): Promise<InitiativeApiModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    initiativesPOST(vaultId: number, body?: InitiativeCreationRequest | undefined): Promise<InitiativeApiModel>;

    /**
     * @return Success
     */
    initiativesGET(vaultId: number, initiativeId: number): Promise<InitiativeApiModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    initiativesPUT(vaultId: number, initiativeId: number, body?: InitiativeUpdateRequest | undefined): Promise<InitiativeApiModel>;

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    initiativesDELETE(vaultId: number, initiativeId: number, shouldDelete?: boolean | undefined): Promise<InitiativeApiModel>;

    /**
     * @return Success
     */
    subGoalsAll(vaultId: number, boardId: number, goalId: number): Promise<SubGoalApiModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    subGoalsPOST(vaultId: number, boardId: number, goalId: number, body?: SubGoalCreationRequest | undefined): Promise<SubGoalApiModel>;

    /**
     * @return Success
     */
    subGoalsGET(vaultId: number, boardId: number, goalId: number, subGoalId: number): Promise<SubGoalApiModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    subGoalsPUT(vaultId: number, boardId: number, goalId: number, subGoalId: number, body?: SubGoalUpdateRequest | undefined): Promise<SubGoalApiModel>;

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    subGoalsDELETE(vaultId: number, boardId: number, goalId: number, subGoalId: number, shouldDelete?: boolean | undefined): Promise<SubGoalApiModel>;

    /**
     * @return Success
     */
    taskItemsAll(vaultId: number, boardId: number, taskListId: number): Promise<TaskItemApiModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    taskItemsPOST(vaultId: number, boardId: number, taskListId: number, body?: TaskItemCreationRequest | undefined): Promise<TaskItemApiModel>;

    /**
     * @return Success
     */
    taskItemsGET(vaultId: number, boardId: number, taskListId: number, taskItemId: number): Promise<TaskItemApiModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    taskItemsPUT(vaultId: number, boardId: number, taskListId: number, taskItemId: number, body?: TaskItemUpdateRequest | undefined): Promise<TaskItemApiModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    move(vaultId: number, boardId: number, taskListId: number, taskItemId: number, body?: TaskMoveRequest | undefined): Promise<TaskItemApiModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    transfer(vaultId: number, boardId: number, taskListId: number, taskItemId: number, body?: TaskTransferRequest | undefined): Promise<TaskItemApiModel>;

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    taskItemsDELETE(vaultId: number, boardId: number, taskListId: number, taskItemId: number, shouldDelete?: boolean | undefined): Promise<TaskItemApiModel>;

    /**
     * @return Success
     */
    taskListsAll(vaultId: number, boardId: number): Promise<TaskListApiModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    taskListsPOST(vaultId: number, boardId: number, body?: TaskListCreationRequest | undefined): Promise<TaskListApiModel>;

    /**
     * @return Success
     */
    taskListsGET(vaultId: number, boardId: number, taskListId: number): Promise<TaskListApiModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    taskListsPUT(vaultId: number, boardId: number, taskListId: number, body?: TaskListUpdateRequest | undefined): Promise<TaskListApiModel>;

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    taskListsDELETE(vaultId: number, boardId: number, taskListId: number, shouldDelete?: boolean | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    position(vaultId: number, boardId: number, taskListId: number, body?: TaskReorderRequest | undefined): Promise<TaskListApiModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    transfer2(vaultId: number, boardId: number, taskListId: number, body?: TaskListTransferRequest | undefined): Promise<TaskListApiModel>;
}

export class TaskboardsClient extends VectorClientBase implements ITaskboardsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    boardsAll(vaultId: number): Promise<BoardApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/Boards";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBoardsAll(_response));
        });
    }

    protected processBoardsAll(response: Response): Promise<BoardApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoardApiModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    boardsPOST(vaultId: number, body?: BoardCreationRequest | undefined): Promise<BoardApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/Boards";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBoardsPOST(_response));
        });
    }

    protected processBoardsPOST(response: Response): Promise<BoardApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoardApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoardApiModel>(null as any);
    }

    /**
     * @return Success
     */
    archived(vaultId: number): Promise<BoardApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/Boards/archived";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchived(_response));
        });
    }

    protected processArchived(response: Response): Promise<BoardApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BoardApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoardApiModel[]>(null as any);
    }

    /**
     * @return Success
     */
    boardsGET(vaultId: number, boardId: number): Promise<BoardApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/Boards/{boardId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBoardsGET(_response));
        });
    }

    protected processBoardsGET(response: Response): Promise<BoardApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoardApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoardApiModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    boardsPUT(vaultId: number, boardId: number, body?: BoardUpdateRequest | undefined): Promise<BoardApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/Boards/{boardId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBoardsPUT(_response));
        });
    }

    protected processBoardsPUT(response: Response): Promise<BoardApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoardApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoardApiModel>(null as any);
    }

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    boardsDELETE(vaultId: number, boardId: number, shouldDelete?: boolean | undefined): Promise<BoardApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/Boards/{boardId}?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBoardsDELETE(_response));
        });
    }

    protected processBoardsDELETE(response: Response): Promise<BoardApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoardApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoardApiModel>(null as any);
    }

    /**
     * @return Success
     */
    export(vaultId: number, boardId: number): Promise<BoardExportModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/Boards/{boardId}/export";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<BoardExportModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoardExportModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoardExportModel>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    import(vaultId: number, file?: FileParameter | undefined): Promise<BoardApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/Boards/import";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImport(_response));
        });
    }

    protected processImport(response: Response): Promise<BoardApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoardApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoardApiModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    protect(vaultId: number, boardId: number, body?: BoardProtectionRequest | undefined): Promise<BoardProtectionResult> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/Boards/{boardId}/protect";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProtect(_response));
        });
    }

    protected processProtect(response: Response): Promise<BoardProtectionResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoardProtectionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoardProtectionResult>(null as any);
    }

    /**
     * @return Success
     */
    unarchive(vaultId: number, boardId: number): Promise<BoardApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/Boards/{boardId}/unarchive";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchive(_response));
        });
    }

    protected processUnarchive(response: Response): Promise<BoardApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoardApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoardApiModel>(null as any);
    }

    /**
     * @return Success
     */
    goalsAll(vaultId: number, boardId: number): Promise<GoalApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/Goals";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGoalsAll(_response));
        });
    }

    protected processGoalsAll(response: Response): Promise<GoalApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GoalApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalApiModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    goalsPOST(vaultId: number, boardId: number, body?: GoalCreationRequest | undefined): Promise<GoalApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/Goals";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGoalsPOST(_response));
        });
    }

    protected processGoalsPOST(response: Response): Promise<GoalApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoalApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalApiModel>(null as any);
    }

    /**
     * @return Success
     */
    goalsGET(vaultId: number, boardId: number, goalId: number): Promise<TaskListApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/Goals/{goalId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (goalId === undefined || goalId === null)
            throw new Error("The parameter 'goalId' must be defined.");
        url_ = url_.replace("{goalId}", encodeURIComponent("" + goalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGoalsGET(_response));
        });
    }

    protected processGoalsGET(response: Response): Promise<TaskListApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskListApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListApiModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    goalsPUT(vaultId: number, boardId: number, goalId: number, body?: GoalUpdateRequest | undefined): Promise<TaskListApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/Goals/{goalId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (goalId === undefined || goalId === null)
            throw new Error("The parameter 'goalId' must be defined.");
        url_ = url_.replace("{goalId}", encodeURIComponent("" + goalId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGoalsPUT(_response));
        });
    }

    protected processGoalsPUT(response: Response): Promise<TaskListApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskListApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListApiModel>(null as any);
    }

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    goalsDELETE(vaultId: number, boardId: number, goalId: number, shouldDelete?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/Goals/{goalId}?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (goalId === undefined || goalId === null)
            throw new Error("The parameter 'goalId' must be defined.");
        url_ = url_.replace("{goalId}", encodeURIComponent("" + goalId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGoalsDELETE(_response));
        });
    }

    protected processGoalsDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    initiativesAll(vaultId: number): Promise<InitiativeApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/Initiatives";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInitiativesAll(_response));
        });
    }

    protected processInitiativesAll(response: Response): Promise<InitiativeApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InitiativeApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InitiativeApiModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    initiativesPOST(vaultId: number, body?: InitiativeCreationRequest | undefined): Promise<InitiativeApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/Initiatives";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInitiativesPOST(_response));
        });
    }

    protected processInitiativesPOST(response: Response): Promise<InitiativeApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InitiativeApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InitiativeApiModel>(null as any);
    }

    /**
     * @return Success
     */
    initiativesGET(vaultId: number, initiativeId: number): Promise<InitiativeApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/Initiatives/{initiativeId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (initiativeId === undefined || initiativeId === null)
            throw new Error("The parameter 'initiativeId' must be defined.");
        url_ = url_.replace("{initiativeId}", encodeURIComponent("" + initiativeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInitiativesGET(_response));
        });
    }

    protected processInitiativesGET(response: Response): Promise<InitiativeApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InitiativeApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InitiativeApiModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    initiativesPUT(vaultId: number, initiativeId: number, body?: InitiativeUpdateRequest | undefined): Promise<InitiativeApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/Initiatives/{initiativeId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (initiativeId === undefined || initiativeId === null)
            throw new Error("The parameter 'initiativeId' must be defined.");
        url_ = url_.replace("{InitiativeId}", encodeURIComponent("" + initiativeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInitiativesPUT(_response));
        });
    }

    protected processInitiativesPUT(response: Response): Promise<InitiativeApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InitiativeApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InitiativeApiModel>(null as any);
    }

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    initiativesDELETE(vaultId: number, initiativeId: number, shouldDelete?: boolean | undefined): Promise<InitiativeApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/Initiatives/{initiativeId}?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (initiativeId === undefined || initiativeId === null)
            throw new Error("The parameter 'initiativeId' must be defined.");
        url_ = url_.replace("{initiativeId}", encodeURIComponent("" + initiativeId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInitiativesDELETE(_response));
        });
    }

    protected processInitiativesDELETE(response: Response): Promise<InitiativeApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InitiativeApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InitiativeApiModel>(null as any);
    }

    /**
     * @return Success
     */
    subGoalsAll(vaultId: number, boardId: number, goalId: number): Promise<SubGoalApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/goals/{goalId}/SubGoals";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (goalId === undefined || goalId === null)
            throw new Error("The parameter 'goalId' must be defined.");
        url_ = url_.replace("{goalId}", encodeURIComponent("" + goalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubGoalsAll(_response));
        });
    }

    protected processSubGoalsAll(response: Response): Promise<SubGoalApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubGoalApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubGoalApiModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    subGoalsPOST(vaultId: number, boardId: number, goalId: number, body?: SubGoalCreationRequest | undefined): Promise<SubGoalApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/goals/{goalId}/SubGoals";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (goalId === undefined || goalId === null)
            throw new Error("The parameter 'goalId' must be defined.");
        url_ = url_.replace("{goalId}", encodeURIComponent("" + goalId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubGoalsPOST(_response));
        });
    }

    protected processSubGoalsPOST(response: Response): Promise<SubGoalApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubGoalApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubGoalApiModel>(null as any);
    }

    /**
     * @return Success
     */
    subGoalsGET(vaultId: number, boardId: number, goalId: number, subGoalId: number): Promise<SubGoalApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/goals/{goalId}/SubGoals/{subGoalId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (goalId === undefined || goalId === null)
            throw new Error("The parameter 'goalId' must be defined.");
        url_ = url_.replace("{goalId}", encodeURIComponent("" + goalId));
        if (subGoalId === undefined || subGoalId === null)
            throw new Error("The parameter 'subGoalId' must be defined.");
        url_ = url_.replace("{subGoalId}", encodeURIComponent("" + subGoalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubGoalsGET(_response));
        });
    }

    protected processSubGoalsGET(response: Response): Promise<SubGoalApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubGoalApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubGoalApiModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    subGoalsPUT(vaultId: number, boardId: number, goalId: number, subGoalId: number, body?: SubGoalUpdateRequest | undefined): Promise<SubGoalApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/goals/{goalId}/SubGoals/{subGoalId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (goalId === undefined || goalId === null)
            throw new Error("The parameter 'goalId' must be defined.");
        url_ = url_.replace("{goalId}", encodeURIComponent("" + goalId));
        if (subGoalId === undefined || subGoalId === null)
            throw new Error("The parameter 'subGoalId' must be defined.");
        url_ = url_.replace("{subGoalId}", encodeURIComponent("" + subGoalId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubGoalsPUT(_response));
        });
    }

    protected processSubGoalsPUT(response: Response): Promise<SubGoalApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubGoalApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubGoalApiModel>(null as any);
    }

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    subGoalsDELETE(vaultId: number, boardId: number, goalId: number, subGoalId: number, shouldDelete?: boolean | undefined): Promise<SubGoalApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/goals/{goalId}/SubGoals/{subGoalId}?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (goalId === undefined || goalId === null)
            throw new Error("The parameter 'goalId' must be defined.");
        url_ = url_.replace("{goalId}", encodeURIComponent("" + goalId));
        if (subGoalId === undefined || subGoalId === null)
            throw new Error("The parameter 'subGoalId' must be defined.");
        url_ = url_.replace("{subGoalId}", encodeURIComponent("" + subGoalId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubGoalsDELETE(_response));
        });
    }

    protected processSubGoalsDELETE(response: Response): Promise<SubGoalApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubGoalApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubGoalApiModel>(null as any);
    }

    /**
     * @return Success
     */
    taskItemsAll(vaultId: number, boardId: number, taskListId: number): Promise<TaskItemApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/tasklists/{taskListId}/TaskItems";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (taskListId === undefined || taskListId === null)
            throw new Error("The parameter 'taskListId' must be defined.");
        url_ = url_.replace("{taskListId}", encodeURIComponent("" + taskListId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTaskItemsAll(_response));
        });
    }

    protected processTaskItemsAll(response: Response): Promise<TaskItemApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskItemApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItemApiModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    taskItemsPOST(vaultId: number, boardId: number, taskListId: number, body?: TaskItemCreationRequest | undefined): Promise<TaskItemApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/tasklists/{taskListId}/TaskItems";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (taskListId === undefined || taskListId === null)
            throw new Error("The parameter 'taskListId' must be defined.");
        url_ = url_.replace("{taskListId}", encodeURIComponent("" + taskListId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTaskItemsPOST(_response));
        });
    }

    protected processTaskItemsPOST(response: Response): Promise<TaskItemApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskItemApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItemApiModel>(null as any);
    }

    /**
     * @return Success
     */
    taskItemsGET(vaultId: number, boardId: number, taskListId: number, taskItemId: number): Promise<TaskItemApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/tasklists/{taskListId}/TaskItems/{taskItemId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (taskListId === undefined || taskListId === null)
            throw new Error("The parameter 'taskListId' must be defined.");
        url_ = url_.replace("{taskListId}", encodeURIComponent("" + taskListId));
        if (taskItemId === undefined || taskItemId === null)
            throw new Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTaskItemsGET(_response));
        });
    }

    protected processTaskItemsGET(response: Response): Promise<TaskItemApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskItemApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItemApiModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    taskItemsPUT(vaultId: number, boardId: number, taskListId: number, taskItemId: number, body?: TaskItemUpdateRequest | undefined): Promise<TaskItemApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/tasklists/{taskListId}/TaskItems/{taskItemId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (taskListId === undefined || taskListId === null)
            throw new Error("The parameter 'taskListId' must be defined.");
        url_ = url_.replace("{taskListId}", encodeURIComponent("" + taskListId));
        if (taskItemId === undefined || taskItemId === null)
            throw new Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTaskItemsPUT(_response));
        });
    }

    protected processTaskItemsPUT(response: Response): Promise<TaskItemApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskItemApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItemApiModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    move(vaultId: number, boardId: number, taskListId: number, taskItemId: number, body?: TaskMoveRequest | undefined): Promise<TaskItemApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/tasklists/{taskListId}/TaskItems/{taskItemId}/move";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (taskListId === undefined || taskListId === null)
            throw new Error("The parameter 'taskListId' must be defined.");
        url_ = url_.replace("{taskListId}", encodeURIComponent("" + taskListId));
        if (taskItemId === undefined || taskItemId === null)
            throw new Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMove(_response));
        });
    }

    protected processMove(response: Response): Promise<TaskItemApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskItemApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItemApiModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    transfer(vaultId: number, boardId: number, taskListId: number, taskItemId: number, body?: TaskTransferRequest | undefined): Promise<TaskItemApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/tasklists/{taskListId}/TaskItems/{taskItemId}/transfer";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (taskListId === undefined || taskListId === null)
            throw new Error("The parameter 'taskListId' must be defined.");
        url_ = url_.replace("{taskListId}", encodeURIComponent("" + taskListId));
        if (taskItemId === undefined || taskItemId === null)
            throw new Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTransfer(_response));
        });
    }

    protected processTransfer(response: Response): Promise<TaskItemApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskItemApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItemApiModel>(null as any);
    }

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    taskItemsDELETE(vaultId: number, boardId: number, taskListId: number, taskItemId: number, shouldDelete?: boolean | undefined): Promise<TaskItemApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/tasklists/{taskListId}/TaskItems/{taskitemId}?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (taskListId === undefined || taskListId === null)
            throw new Error("The parameter 'taskListId' must be defined.");
        url_ = url_.replace("{taskListId}", encodeURIComponent("" + taskListId));
        if (taskItemId === undefined || taskItemId === null)
            throw new Error("The parameter 'taskItemId' must be defined.");
        url_ = url_.replace("{taskItemId}", encodeURIComponent("" + taskItemId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTaskItemsDELETE(_response));
        });
    }

    protected processTaskItemsDELETE(response: Response): Promise<TaskItemApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskItemApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItemApiModel>(null as any);
    }

    /**
     * @return Success
     */
    taskListsAll(vaultId: number, boardId: number): Promise<TaskListApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/TaskLists";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTaskListsAll(_response));
        });
    }

    protected processTaskListsAll(response: Response): Promise<TaskListApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskListApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListApiModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    taskListsPOST(vaultId: number, boardId: number, body?: TaskListCreationRequest | undefined): Promise<TaskListApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/TaskLists";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTaskListsPOST(_response));
        });
    }

    protected processTaskListsPOST(response: Response): Promise<TaskListApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskListApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListApiModel>(null as any);
    }

    /**
     * @return Success
     */
    taskListsGET(vaultId: number, boardId: number, taskListId: number): Promise<TaskListApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/TaskLists/{taskListId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (taskListId === undefined || taskListId === null)
            throw new Error("The parameter 'taskListId' must be defined.");
        url_ = url_.replace("{taskListId}", encodeURIComponent("" + taskListId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTaskListsGET(_response));
        });
    }

    protected processTaskListsGET(response: Response): Promise<TaskListApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskListApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListApiModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    taskListsPUT(vaultId: number, boardId: number, taskListId: number, body?: TaskListUpdateRequest | undefined): Promise<TaskListApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/TaskLists/{taskListId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (taskListId === undefined || taskListId === null)
            throw new Error("The parameter 'taskListId' must be defined.");
        url_ = url_.replace("{taskListId}", encodeURIComponent("" + taskListId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTaskListsPUT(_response));
        });
    }

    protected processTaskListsPUT(response: Response): Promise<TaskListApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskListApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListApiModel>(null as any);
    }

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    taskListsDELETE(vaultId: number, boardId: number, taskListId: number, shouldDelete?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/TaskLists/{taskListId}?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (taskListId === undefined || taskListId === null)
            throw new Error("The parameter 'taskListId' must be defined.");
        url_ = url_.replace("{taskListId}", encodeURIComponent("" + taskListId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTaskListsDELETE(_response));
        });
    }

    protected processTaskListsDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    position(vaultId: number, boardId: number, taskListId: number, body?: TaskReorderRequest | undefined): Promise<TaskListApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/TaskLists/{taskListId}/position";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (taskListId === undefined || taskListId === null)
            throw new Error("The parameter 'taskListId' must be defined.");
        url_ = url_.replace("{taskListId}", encodeURIComponent("" + taskListId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPosition(_response));
        });
    }

    protected processPosition(response: Response): Promise<TaskListApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskListApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListApiModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    transfer2(vaultId: number, boardId: number, taskListId: number, body?: TaskListTransferRequest | undefined): Promise<TaskListApiModel> {
        let url_ = this.baseUrl + "/api/apps/ziggy/{vaultId}/boards/{boardId}/TaskLists/{taskListId}/transfer";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (boardId === undefined || boardId === null)
            throw new Error("The parameter 'boardId' must be defined.");
        url_ = url_.replace("{boardId}", encodeURIComponent("" + boardId));
        if (taskListId === undefined || taskListId === null)
            throw new Error("The parameter 'taskListId' must be defined.");
        url_ = url_.replace("{taskListId}", encodeURIComponent("" + taskListId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTransfer2(_response));
        });
    }

    protected processTransfer2(response: Response): Promise<TaskListApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskListApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskListApiModel>(null as any);
    }
}

export class BoardApiModel implements IBoardApiModel {
    id?: number;
    name?: string | undefined;
    goalCount?: number;
    goals?: GoalApiModel[] | undefined;
    taskListCount?: number;
    taskLists?: TaskListApiModel[] | undefined;
    isProtected?: boolean;

    constructor(data?: IBoardApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.goals) {
                this.goals = [];
                for (let i = 0; i < data.goals.length; i++) {
                    let item = data.goals[i];
                    this.goals[i] = item && !(<any>item).toJSON ? new GoalApiModel(item) : <GoalApiModel>item;
                }
            }
            if (data.taskLists) {
                this.taskLists = [];
                for (let i = 0; i < data.taskLists.length; i++) {
                    let item = data.taskLists[i];
                    this.taskLists[i] = item && !(<any>item).toJSON ? new TaskListApiModel(item) : <TaskListApiModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.goalCount = _data["goalCount"];
            if (Array.isArray(_data["goals"])) {
                this.goals = [] as any;
                for (let item of _data["goals"])
                    this.goals!.push(GoalApiModel.fromJS(item));
            }
            this.taskListCount = _data["taskListCount"];
            if (Array.isArray(_data["taskLists"])) {
                this.taskLists = [] as any;
                for (let item of _data["taskLists"])
                    this.taskLists!.push(TaskListApiModel.fromJS(item));
            }
            this.isProtected = _data["isProtected"];
        }
    }

    static fromJS(data: any): BoardApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new BoardApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["goalCount"] = this.goalCount;
        if (Array.isArray(this.goals)) {
            data["goals"] = [];
            for (let item of this.goals)
                data["goals"].push(item.toJSON());
        }
        data["taskListCount"] = this.taskListCount;
        if (Array.isArray(this.taskLists)) {
            data["taskLists"] = [];
            for (let item of this.taskLists)
                data["taskLists"].push(item.toJSON());
        }
        data["isProtected"] = this.isProtected;
        return data;
    }
}

export interface IBoardApiModel {
    id?: number;
    name?: string | undefined;
    goalCount?: number;
    goals?: IGoalApiModel[] | undefined;
    taskListCount?: number;
    taskLists?: ITaskListApiModel[] | undefined;
    isProtected?: boolean;
}

export class BoardCreationRequest implements IBoardCreationRequest {
    name!: string;

    constructor(data?: IBoardCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BoardCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BoardCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IBoardCreationRequest {
    name: string;
}

export class BoardExportModel implements IBoardExportModel {
    name?: string | undefined;
    timeExported?: Date;
    boardName?: string | undefined;
    taskLists?: ExportedTaskList[] | undefined;

    constructor(data?: IBoardExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.taskLists) {
                this.taskLists = [];
                for (let i = 0; i < data.taskLists.length; i++) {
                    let item = data.taskLists[i];
                    this.taskLists[i] = item && !(<any>item).toJSON ? new ExportedTaskList(item) : <ExportedTaskList>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.timeExported = _data["timeExported"] ? new Date(_data["timeExported"].toString()) : <any>undefined;
            this.boardName = _data["boardName"];
            if (Array.isArray(_data["taskLists"])) {
                this.taskLists = [] as any;
                for (let item of _data["taskLists"])
                    this.taskLists!.push(ExportedTaskList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BoardExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new BoardExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["timeExported"] = this.timeExported ? this.timeExported.toISOString() : <any>undefined;
        data["boardName"] = this.boardName;
        if (Array.isArray(this.taskLists)) {
            data["taskLists"] = [];
            for (let item of this.taskLists)
                data["taskLists"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBoardExportModel {
    name?: string | undefined;
    timeExported?: Date;
    boardName?: string | undefined;
    taskLists?: IExportedTaskList[] | undefined;
}

export class BoardProtectionRequest implements IBoardProtectionRequest {
    protectBoard!: boolean;
    protectionKeyId!: string;
    commitChanges!: boolean;

    constructor(data?: IBoardProtectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.protectBoard = _data["protectBoard"];
            this.protectionKeyId = _data["protectionKeyId"];
            this.commitChanges = _data["commitChanges"];
        }
    }

    static fromJS(data: any): BoardProtectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BoardProtectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["protectBoard"] = this.protectBoard;
        data["protectionKeyId"] = this.protectionKeyId;
        data["commitChanges"] = this.commitChanges;
        return data;
    }
}

export interface IBoardProtectionRequest {
    protectBoard: boolean;
    protectionKeyId: string;
    commitChanges: boolean;
}

export class BoardProtectionResult implements IBoardProtectionResult {
    protectionSuccessful?: boolean;

    constructor(data?: IBoardProtectionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.protectionSuccessful = _data["protectionSuccessful"];
        }
    }

    static fromJS(data: any): BoardProtectionResult {
        data = typeof data === 'object' ? data : {};
        let result = new BoardProtectionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["protectionSuccessful"] = this.protectionSuccessful;
        return data;
    }
}

export interface IBoardProtectionResult {
    protectionSuccessful?: boolean;
}

export class BoardUpdateRequest implements IBoardUpdateRequest {
    newParentId!: number;
    name?: string | undefined;

    constructor(data?: IBoardUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newParentId = _data["newParentId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BoardUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BoardUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newParentId"] = this.newParentId;
        data["name"] = this.name;
        return data;
    }
}

export interface IBoardUpdateRequest {
    newParentId: number;
    name?: string | undefined;
}

export class ExportedInitiative implements IExportedInitiative {
    name?: string | undefined;

    constructor(data?: IExportedInitiative) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ExportedInitiative {
        data = typeof data === 'object' ? data : {};
        let result = new ExportedInitiative();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IExportedInitiative {
    name?: string | undefined;
}

export class ExportedTaskItem implements IExportedTaskItem {
    title?: string | undefined;
    description?: string | undefined;
    status?: TaskStatus;
    initiatives?: ExportedInitiative[] | undefined;

    constructor(data?: IExportedTaskItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.initiatives) {
                this.initiatives = [];
                for (let i = 0; i < data.initiatives.length; i++) {
                    let item = data.initiatives[i];
                    this.initiatives[i] = item && !(<any>item).toJSON ? new ExportedInitiative(item) : <ExportedInitiative>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
            if (Array.isArray(_data["initiatives"])) {
                this.initiatives = [] as any;
                for (let item of _data["initiatives"])
                    this.initiatives!.push(ExportedInitiative.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportedTaskItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExportedTaskItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        if (Array.isArray(this.initiatives)) {
            data["initiatives"] = [];
            for (let item of this.initiatives)
                data["initiatives"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportedTaskItem {
    title?: string | undefined;
    description?: string | undefined;
    status?: TaskStatus;
    initiatives?: IExportedInitiative[] | undefined;
}

export class ExportedTaskList implements IExportedTaskList {
    name?: string | undefined;
    lifecycleStage?: TaskLifecycle;
    taskItems?: ExportedTaskItem[] | undefined;

    constructor(data?: IExportedTaskList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.taskItems) {
                this.taskItems = [];
                for (let i = 0; i < data.taskItems.length; i++) {
                    let item = data.taskItems[i];
                    this.taskItems[i] = item && !(<any>item).toJSON ? new ExportedTaskItem(item) : <ExportedTaskItem>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.lifecycleStage = _data["lifecycleStage"];
            if (Array.isArray(_data["taskItems"])) {
                this.taskItems = [] as any;
                for (let item of _data["taskItems"])
                    this.taskItems!.push(ExportedTaskItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportedTaskList {
        data = typeof data === 'object' ? data : {};
        let result = new ExportedTaskList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lifecycleStage"] = this.lifecycleStage;
        if (Array.isArray(this.taskItems)) {
            data["taskItems"] = [];
            for (let item of this.taskItems)
                data["taskItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportedTaskList {
    name?: string | undefined;
    lifecycleStage?: TaskLifecycle;
    taskItems?: IExportedTaskItem[] | undefined;
}

export class GoalApiModel implements IGoalApiModel {
    id?: number;
    description?: string | undefined;
    subGoalCount?: number;
    subGoals?: SubGoalApiModel[] | undefined;

    constructor(data?: IGoalApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.subGoals) {
                this.subGoals = [];
                for (let i = 0; i < data.subGoals.length; i++) {
                    let item = data.subGoals[i];
                    this.subGoals[i] = item && !(<any>item).toJSON ? new SubGoalApiModel(item) : <SubGoalApiModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.subGoalCount = _data["subGoalCount"];
            if (Array.isArray(_data["subGoals"])) {
                this.subGoals = [] as any;
                for (let item of _data["subGoals"])
                    this.subGoals!.push(SubGoalApiModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GoalApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new GoalApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["subGoalCount"] = this.subGoalCount;
        if (Array.isArray(this.subGoals)) {
            data["subGoals"] = [];
            for (let item of this.subGoals)
                data["subGoals"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGoalApiModel {
    id?: number;
    description?: string | undefined;
    subGoalCount?: number;
    subGoals?: ISubGoalApiModel[] | undefined;
}

export class GoalCreationRequest implements IGoalCreationRequest {
    description!: string;

    constructor(data?: IGoalCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GoalCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GoalCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }
}

export interface IGoalCreationRequest {
    description: string;
}

export class GoalUpdateRequest implements IGoalUpdateRequest {
    newParentId!: number;
    description!: string;

    constructor(data?: IGoalUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newParentId = _data["newParentId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GoalUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GoalUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newParentId"] = this.newParentId;
        data["description"] = this.description;
        return data;
    }
}

export interface IGoalUpdateRequest {
    newParentId: number;
    description: string;
}

export class InitiativeApiModel implements IInitiativeApiModel {
    id?: number;
    name?: string | undefined;

    constructor(data?: IInitiativeApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InitiativeApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new InitiativeApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IInitiativeApiModel {
    id?: number;
    name?: string | undefined;
}

export class InitiativeCreationRequest implements IInitiativeCreationRequest {
    name!: string;

    constructor(data?: IInitiativeCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InitiativeCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InitiativeCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IInitiativeCreationRequest {
    name: string;
}

export class InitiativeUpdateRequest implements IInitiativeUpdateRequest {
    newParentId!: number;
    name!: string;

    constructor(data?: IInitiativeUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newParentId = _data["newParentId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InitiativeUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InitiativeUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newParentId"] = this.newParentId;
        data["name"] = this.name;
        return data;
    }
}

export interface IInitiativeUpdateRequest {
    newParentId: number;
    name: string;
}

export class SubGoalApiModel implements ISubGoalApiModel {
    id?: number;
    description?: string | undefined;

    constructor(data?: ISubGoalApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SubGoalApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubGoalApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface ISubGoalApiModel {
    id?: number;
    description?: string | undefined;
}

export class SubGoalCreationRequest implements ISubGoalCreationRequest {
    description!: string;

    constructor(data?: ISubGoalCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SubGoalCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubGoalCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }
}

export interface ISubGoalCreationRequest {
    description: string;
}

export class SubGoalUpdateRequest implements ISubGoalUpdateRequest {
    newParentId!: number;
    description!: string;

    constructor(data?: ISubGoalUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newParentId = _data["newParentId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SubGoalUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubGoalUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newParentId"] = this.newParentId;
        data["description"] = this.description;
        return data;
    }
}

export interface ISubGoalUpdateRequest {
    newParentId: number;
    description: string;
}

export class TaskItemApiModel implements ITaskItemApiModel {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;
    status?: TaskStatus;
    initiatives?: InitiativeApiModel[] | undefined;
    order?: number;

    constructor(data?: ITaskItemApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.initiatives) {
                this.initiatives = [];
                for (let i = 0; i < data.initiatives.length; i++) {
                    let item = data.initiatives[i];
                    this.initiatives[i] = item && !(<any>item).toJSON ? new InitiativeApiModel(item) : <InitiativeApiModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
            if (Array.isArray(_data["initiatives"])) {
                this.initiatives = [] as any;
                for (let item of _data["initiatives"])
                    this.initiatives!.push(InitiativeApiModel.fromJS(item));
            }
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): TaskItemApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskItemApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        if (Array.isArray(this.initiatives)) {
            data["initiatives"] = [];
            for (let item of this.initiatives)
                data["initiatives"].push(item.toJSON());
        }
        data["order"] = this.order;
        return data;
    }
}

export interface ITaskItemApiModel {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;
    status?: TaskStatus;
    initiatives?: IInitiativeApiModel[] | undefined;
    order?: number;
}

export class TaskItemCreationRequest implements ITaskItemCreationRequest {
    title!: string;
    description?: string | undefined;
    status!: TaskStatus;
    initiativeIds!: number[];

    constructor(data?: ITaskItemCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.initiativeIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
            if (Array.isArray(_data["initiativeIds"])) {
                this.initiativeIds = [] as any;
                for (let item of _data["initiativeIds"])
                    this.initiativeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TaskItemCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskItemCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        if (Array.isArray(this.initiativeIds)) {
            data["initiativeIds"] = [];
            for (let item of this.initiativeIds)
                data["initiativeIds"].push(item);
        }
        return data;
    }
}

export interface ITaskItemCreationRequest {
    title: string;
    description?: string | undefined;
    status: TaskStatus;
    initiativeIds: number[];
}

export class TaskItemUpdateRequest implements ITaskItemUpdateRequest {
    newParentId!: number;
    title!: string;
    description!: string;
    status!: TaskStatus;
    initiativeIds!: number[];

    constructor(data?: ITaskItemUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.initiativeIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newParentId = _data["newParentId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
            if (Array.isArray(_data["initiativeIds"])) {
                this.initiativeIds = [] as any;
                for (let item of _data["initiativeIds"])
                    this.initiativeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TaskItemUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskItemUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newParentId"] = this.newParentId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        if (Array.isArray(this.initiativeIds)) {
            data["initiativeIds"] = [];
            for (let item of this.initiativeIds)
                data["initiativeIds"].push(item);
        }
        return data;
    }
}

export interface ITaskItemUpdateRequest {
    newParentId: number;
    title: string;
    description: string;
    status: TaskStatus;
    initiativeIds: number[];
}

export enum TaskLifecycle {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export class TaskLifecycleApiModel implements ITaskLifecycleApiModel {
    customName?: string | undefined;
    lifecycleId?: number;
    isCustom?: boolean;
    customColor?: string | undefined;

    constructor(data?: ITaskLifecycleApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customName = _data["customName"];
            this.lifecycleId = _data["lifecycleId"];
            this.isCustom = _data["isCustom"];
            this.customColor = _data["customColor"];
        }
    }

    static fromJS(data: any): TaskLifecycleApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskLifecycleApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customName"] = this.customName;
        data["lifecycleId"] = this.lifecycleId;
        data["isCustom"] = this.isCustom;
        data["customColor"] = this.customColor;
        return data;
    }
}

export interface ITaskLifecycleApiModel {
    customName?: string | undefined;
    lifecycleId?: number;
    isCustom?: boolean;
    customColor?: string | undefined;
}

export class TaskListApiModel implements ITaskListApiModel {
    id?: number;
    name?: string | undefined;
    lifecycleStage?: TaskLifecycleApiModel;
    taskItemCount?: number;
    taskItems?: TaskItemApiModel[] | undefined;
    order?: number;

    constructor(data?: ITaskListApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.lifecycleStage = data.lifecycleStage && !(<any>data.lifecycleStage).toJSON ? new TaskLifecycleApiModel(data.lifecycleStage) : <TaskLifecycleApiModel>this.lifecycleStage;
            if (data.taskItems) {
                this.taskItems = [];
                for (let i = 0; i < data.taskItems.length; i++) {
                    let item = data.taskItems[i];
                    this.taskItems[i] = item && !(<any>item).toJSON ? new TaskItemApiModel(item) : <TaskItemApiModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.lifecycleStage = _data["lifecycleStage"] ? TaskLifecycleApiModel.fromJS(_data["lifecycleStage"]) : <any>undefined;
            this.taskItemCount = _data["taskItemCount"];
            if (Array.isArray(_data["taskItems"])) {
                this.taskItems = [] as any;
                for (let item of _data["taskItems"])
                    this.taskItems!.push(TaskItemApiModel.fromJS(item));
            }
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): TaskListApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskListApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["lifecycleStage"] = this.lifecycleStage ? this.lifecycleStage.toJSON() : <any>undefined;
        data["taskItemCount"] = this.taskItemCount;
        if (Array.isArray(this.taskItems)) {
            data["taskItems"] = [];
            for (let item of this.taskItems)
                data["taskItems"].push(item.toJSON());
        }
        data["order"] = this.order;
        return data;
    }
}

export interface ITaskListApiModel {
    id?: number;
    name?: string | undefined;
    lifecycleStage?: ITaskLifecycleApiModel;
    taskItemCount?: number;
    taskItems?: ITaskItemApiModel[] | undefined;
    order?: number;
}

export class TaskListCreationRequest implements ITaskListCreationRequest {
    name!: string;

    constructor(data?: ITaskListCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TaskListCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskListCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ITaskListCreationRequest {
    name: string;
}

export class TaskListTransferRequest implements ITaskListTransferRequest {
    destinationVaultId?: number;
    destinationBoardId?: number;

    constructor(data?: ITaskListTransferRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinationVaultId = _data["destinationVaultId"];
            this.destinationBoardId = _data["destinationBoardId"];
        }
    }

    static fromJS(data: any): TaskListTransferRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskListTransferRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationVaultId"] = this.destinationVaultId;
        data["destinationBoardId"] = this.destinationBoardId;
        return data;
    }
}

export interface ITaskListTransferRequest {
    destinationVaultId?: number;
    destinationBoardId?: number;
}

export class TaskListUpdateRequest implements ITaskListUpdateRequest {
    newParentId!: number;
    name!: string;
    lifeCycleStage!: number;
    lifeCycleStageIsCustom?: boolean;

    constructor(data?: ITaskListUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newParentId = _data["newParentId"];
            this.name = _data["name"];
            this.lifeCycleStage = _data["lifeCycleStage"];
            this.lifeCycleStageIsCustom = _data["lifeCycleStageIsCustom"];
        }
    }

    static fromJS(data: any): TaskListUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskListUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newParentId"] = this.newParentId;
        data["name"] = this.name;
        data["lifeCycleStage"] = this.lifeCycleStage;
        data["lifeCycleStageIsCustom"] = this.lifeCycleStageIsCustom;
        return data;
    }
}

export interface ITaskListUpdateRequest {
    newParentId: number;
    name: string;
    lifeCycleStage: number;
    lifeCycleStageIsCustom?: boolean;
}

export class TaskMoveRequest implements ITaskMoveRequest {
    destinationTaskListId?: number;
    position?: number;

    constructor(data?: ITaskMoveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinationTaskListId = _data["destinationTaskListId"];
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): TaskMoveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskMoveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationTaskListId"] = this.destinationTaskListId;
        data["position"] = this.position;
        return data;
    }
}

export interface ITaskMoveRequest {
    destinationTaskListId?: number;
    position?: number;
}

export class TaskReorderRequest implements ITaskReorderRequest {
    position?: number;

    constructor(data?: ITaskReorderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): TaskReorderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskReorderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        return data;
    }
}

export interface ITaskReorderRequest {
    position?: number;
}

export enum TaskStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class TaskTransferRequest implements ITaskTransferRequest {
    destinationBoardId?: number;
    destinationTaskListId?: number;

    constructor(data?: ITaskTransferRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinationBoardId = _data["destinationBoardId"];
            this.destinationTaskListId = _data["destinationTaskListId"];
        }
    }

    static fromJS(data: any): TaskTransferRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskTransferRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationBoardId"] = this.destinationBoardId;
        data["destinationTaskListId"] = this.destinationTaskListId;
        return data;
    }
}

export interface ITaskTransferRequest {
    destinationBoardId?: number;
    destinationTaskListId?: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}